import type { HomeResponse } from "../shared/dto";
import { railInteractionForStep, type RailStep, type RailTarget } from "./rail-model";
import { journeyFinished } from "./journey-end";

/**
 * 🔴 fix-homereview scope 2 (Pavel 2026-08-19, his THIRD time, verbatim):
 * "Žádná domovská stránka klienta nemá existovat. Má ho to dávat na tu
 * stránku, kterou má odemčenou a se kterou má pracovat."
 *
 * Where a load with NO explicit destination lands - one derivation, because
 * the rail, the mobile switcher and the landing must never disagree about
 * which step is the client's (the F126 law on the client side). The current
 * step is the rail's own `primaryNext` flag, never a second walk over the
 * states.
 *
 * Three honest nulls, each a state where the HOME is the right page:
 * - a finished journey has no current step; the finished card IS the
 *   destination (F152-W4), and its salespage-next take-away phases must not
 *   drag a finished client into a step page.
 * - no step carries the pointer (the team owns every open thing): the home
 *   says whose turn it is.
 * - the current step is not the client's to open (`clientStepLocked` - the
 *   ONE lock gate): landing there would draw the LockedStep refusal or a
 *   team-working page that says "nothing to do here". Pavel's sentence is
 *   about the page the client "má odemčenou"; a locked one is not it.
 *
 * The caller dispatches the target exactly as a rail click does (q1/q2 open
 * the questionnaire, everything else its surface).
 */
export function defaultLandingTarget(
  home: HomeResponse,
  steps: ReadonlyArray<RailStep>
): RailTarget | null {
  if (journeyFinished(home)) return null;
  const current = steps.find((step) => step.primaryNext) ?? null;
  if (!current) return null;
  const { clickable, target } = railInteractionForStep(current);
  return clickable ? target : null;
}
